var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.hasBar == 1)?[_c('siderbar'),_vm._v(" "),_c('div',{staticClass:"my-container"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"clear"})]:_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }